import MuiEmailIcon from '@material-ui/icons/Email';
export const EmailIcon = MuiEmailIcon;